module.exports = __webpack_public_path__ + "img/main_top_img.6fcadd44.png";